import axios from 'axios';
import API from '../config/api';
import { resHandle } from '../helper';

export const featureCategoryListService = params => axios.get(API.FEATURE_CATEGORY_LIST + params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const featureCategoryByIdService = params => axios.get(API.FEATURE_CATEGORY_BY_ID + params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const featureCategoryDropdownService = params => axios.get(API.FEATURE_CATEGORY_DROPDOWN + params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const featureCategoryCreateService = params => axios.post(API.CREATE_FEATURE_CATEGORY, params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const featureCategoryUpdateService = params => axios.post(API.UPDATE_FEATURE_CATEGORY, params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const featureCategoryDeleteService = params => axios.post(API.DELETE_FEATURE_CATEGORY, params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});
